import { NumberFormatter } from '@ddt-web/data-service';
import * as get from 'lodash/get';

import { StackedDataUtil } from '../../data-mapper/utils';
import { IHighChartsAttributesModel } from '../../models/high-charts-attributes.interface';
import { BaseChartWorker } from '../common';

/**
 * StackedGroupedColumnWorker: chart worker specific to the scenario analysis column chart.
 * @param {any} config JSON object representing the chart configuration.
 * @param {IHighChartsAttributesModel} highChartsAttributes an object containing properties used to augment the chart configuration.
 */
export class StackedGroupedColumnWorker extends BaseChartWorker {
	constructor(config: any, highChartsAttributes: IHighChartsAttributesModel) {
		super(config, highChartsAttributes);
		if (this.highChartsAttributes.isPdf) {
			this.initChartForPdf();
		} else {
			this.initChartForWeb();
		}
	}

	private initChartForWeb(): void {
		this.initTooltip();
	}

	private initChartForPdf(): void { }

	private initTooltip(): void {
		const colors = this.config.colors;
		this.config.tooltip.formatter = function (): string {
			const stackName = get(this.point, 'series.userOptions.stack') || get(this.point, 'series.stackKey', '').replace('column', '');
			const portfolioIndex = this.series.chart.options.extensibleData.portfolios.findIndex(x => x === stackName);
			const numberFormatter = new NumberFormatter('%');
			let tooltipHtml = '';
			let sum = 0;
			const seriesLength = this.series.chart.options.extensibleData.series.length;
			this.series.chart.options.extensibleData.series.forEach((category, index) => {
				let defaultStyleOption = `class="legend-item" style="color: ${colors[index]}"`;
				if (this.series.chart.options.extensibleData.portfolios > 1) {
					defaultStyleOption = `class="legend-item legend_${portfolioIndex}_${category.name.replace(/ /g, '')}`;
				}
				if (category.stack === stackName) {
					sum += Number(category.data[this.point.index]);
					tooltipHtml += `
						<div class="wrapper" style="order:${seriesLength - index}">
							<div ${defaultStyleOption}>&#9679</div>
							<div class="grid-item">
								<span>${category.name}</span>
							</div>
							<div class="grid-item category-values">
								${numberFormatter.format(category.data[this.point.index])}
							</div>
						</div>
						`;
				}
			});
			const render = `
			<div class="tooltip-container">
				<div class="inner-content">
					<div class="tooltip-title wrapper">
						<div class="header-item">
							<span>${stackName}</span>
						</div>
						<div class="grid-item category-values">
							<span>${numberFormatter.format(sum)}</span>
						</div>
					</div>
					${tooltipHtml}
				</div>
			</div>
			`;
			return render;
		};
	}

	/**
	 * transformData: transform the data into consumable format for the scenario analysis column chart.
	 */
	public transformData(): void {
		const transformedData = StackedDataUtil.getStackedData(this.highChartsAttributes.tabData, this.highChartsAttributes.portfolioIndex);
		const series = transformedData.series;
		series.reverse();
		const portfolios = transformedData.portfolios;
		this.config.extensibleData = { series, portfolios };
		this.config.series = series;
		this.config.xAxis.categories = transformedData.scenarios;
	}
}
